import React from "react";

const Text = ({ defaultValue, ...otherProps }) => {
	return <span {...otherProps}>{typeof defaultValue === "object" ? "" : defaultValue}</span>;
};
//todo: strip out typeof once we fix it at question container
export default Text;
